import React from 'react';
import {Button, Icon} from "antd";
import ls from './FormEditor.less';

export class DesignErrorScope extends React.Component {

  state = {hasError: false};

  render() {
    if (this.state.hasError) {
      return <div className={ls.misconfigured}>
        <Icon type='warning' theme="twoTone" twoToneColor="#EBAF4C"/> component misconfigured
      </div>;
    }
    return this.props.children;
  }

  componentDidCatch(error) {
    this.setState({hasError: true});
    console.error(error);
  }
}


